
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCusPromotionSaleDialog extends Serenity.EntityDialog<ReportCusPromotionSaleRow, any> {
        protected getFormKey() { return ReportCusPromotionSaleForm.formKey; }
        protected getIdProperty() { return ReportCusPromotionSaleRow.idProperty; }
        protected getLocalTextPrefix() { return ReportCusPromotionSaleRow.localTextPrefix; }
        protected getNameProperty() { return ReportCusPromotionSaleRow.nameProperty; }
        protected getService() { return ReportCusPromotionSaleService.baseUrl; }
        protected getDeletePermission() { return ReportCusPromotionSaleRow.deletePermission; }
        protected getInsertPermission() { return ReportCusPromotionSaleRow.insertPermission; }
        protected getUpdatePermission() { return ReportCusPromotionSaleRow.updatePermission; }

        protected form = new ReportCusPromotionSaleForm(this.idPrefix);

    }
}